<template>
  <div class="users-layout">
    <default-box
        :loader="loading">
      <div class="d-flex justify-content-between align-items-center mb-10">
        <div class="row col-md-8 align-items-center justify-content-start row-column">

        </div>
      </div>
      <tables-slot
          :empty_spacer="loading"
          @paginationFetch="fillData"
          @popstateEvent="getTrashList"
          :pagination="pagination">
        <template v-slot:table_head>
          <td class="w-0 text-nowrap">{{ $t('tables.title') }}</td>
          <td class="w-0 text-nowrap">{{ $t('tables.quantity') }}</td>
          <td class="w-0 text-nowrap">{{ $t('tables.edit') }}</td>
        </template>
        <template v-slot:table_body>
          <tr v-for="(item, key) in trashedItems">
            <td class="w-0 text-nowrap">
              {{ $t('trashed.' + item.table) }}
            </td>
            <td class="w-0 text-nowrap">
              {{ item.count }}
            </td>
            <td class="w-0 text-nowrap">
              <router-link-to
                  class="d-inline-block px-10 py-10"
                  :route_params="{id: key}"
                  :route_name="route_names.trashed">
                <edit-icon/>
              </router-link-to>
            </td>
          </tr>
        </template>
      </tables-slot>
    </default-box>
  </div>
</template>

<script>

import {axiosArticles, axiosTrash} from "../../../helpers/axios_requests";
import {REPLACE_IN_QUERY, REPLACE_STATE} from "../../../helpers/url_helper";
import routes_mixin from "../../../mixins/routes_mixin";
import RouterLinkTo from "../../small_components/RouterLinkTo.vue";
import TablesSlot from "../../small_components/tables/TablesSlot.vue";
import Switcher from "../../small_components/Switcher.vue";
import EditIcon from "../../icons/EditIcon.vue";
import DefaultBox from "../../slots/DefaultBox.vue";
import SearchInput from "../../small_components/SearchInput.vue";
import DefaultInput from "../../small_components/DefaultInput.vue";
import CloseIcon from "../../icons/CloseIcon.vue";
import DefaultButton from "../../small_components/DefaultButton.vue";
import LogoutIcon from "../../icons/LogoutIcon.vue";
import TrashIcon from "../../icons/TrashIcon.vue";
import {FORMAT_ERROR_MESSAGE} from "../../../helpers/validation_error_message";
import {STATUS_ERROR, STATUS_SUCCESS} from "../../../store/modules/notifiocation";
import DefaultSelect from "../../small_components/DefaultSelect.vue";

export default {
  name: 'TrashLayout',
  mixins: [routes_mixin],
  components: {
    DefaultSelect,
    TrashIcon,
    LogoutIcon,
    DefaultButton,
    CloseIcon,
    DefaultInput,
    SearchInput,
    DefaultBox,
    EditIcon,
    Switcher,
    TablesSlot,
    RouterLinkTo,
  },
  computed: {

  },
  beforeMount() {
    this.getTrashList();
  },
  data() {
    return {
      trashedItems: [],
      pagination: [],
      loading: false,
      search: '',
    }
  },
  methods: {
    fillData({collection, pagination}) {
      this.trashedItems = collection || []
      this.pagination = pagination || []
    },

    getTrashList() {
      this.loading = true
      axiosTrash.list()
          .then(r => {
            this.fillData(r.data)
          })
          .finally(() => {
            this.loading = false
          })
    },
  }
}
</script>
